import moment from 'moment';
import { momentUTCToLocalDate } from '../../../shared/helpers/Dates';

export default ({ property, record }) => (record.params[property.name] ? momentUTCToLocalDate(moment(record.params[property.name])).format('M/DD/YYYY') : '');
